import React from 'react'
import { useDispatch } from 'react-redux'

import { setToggleBlacklistStatus, setToggleBlacklistStatusWithMotive } from '../../slices'
import { useModalContext } from '../../../../ui/modal/contexts'
import { MotiveDialog } from '../dialog/motive-dialog.component'
import { ActionCheckbox } from '../../../../ui'

export const BlacklistCheckbox = ({ rowData }) => {
  const dispatch = useDispatch()
  const {
    actions: { open },
  } = useModalContext()

  if (!rowData) {
    return null
  }

  const handleRequireMotive = (row, listType, setIsLoading) => {
    open({
      Component: ({ close }) => (
        <MotiveDialog
          close={close}
          email={row.email}
          onConfirm={(motive) => {
            const rowWithMotive = { ...row, motive: motive || '' }
            dispatch(
              setToggleBlacklistStatusWithMotive(
                rowWithMotive,
                listType,
                motive || '',
                setIsLoading
              )
            )
          }}
        />
      ),
      type: 'responsive',
      maxWidth: 'sm',
      closable: true,
    })
  }

  return (
    <ActionCheckbox
      rowData={rowData}
      checkedField="isInBlacklist"
      actionType="black"
      action={setToggleBlacklistStatus}
      requiresConfirmation={true}
      onRequireConfirmation={handleRequireMotive}
    />
  )
}
